import apiInstance from './api';

const academicTitleApi = apiInstance.injectEndpoints({
  endpoints: (builder) => ({
    getAcademicTitles: builder.query({
      query: () => '/author_academic_titles',
      transformResponse: (response) => response['hydra:member'],

      providesTags: ['AcedemicTitles'],
    }),
  }),
  overrideExisting: true,
});

export default academicTitleApi;
